import { Outlet, useLocation } from 'react-router';

import { useI18n } from '../i18n';
import { useLayoutSeo } from '../lib/seo';
import Footer from './components/Footer';
import Header from './components/Header';

export default function Layout() {
  const { direction, language } = useI18n();
  const location = useLocation();

  useLayoutSeo({ language, pathname: location.pathname });

  return (
    <main dir={direction} lang={language} className="scroll-smooth">
      <Header />
      <Outlet />
      <Footer />
    </main>
  );
}
